import React from "react";
import axios from "axios";
import config from "../../config";
// this is the list of all products in the inventory
// It will be displayed in a table format
// Each row is clickable and will take the user to the product details page
// The user can also add a new product to the inventory on this page
// The user can also delete a product from the inventory on this page

// components
import CardTable from "components/Tables/CardTable.js";

export default function Products() {

    const url = `${config.baseUrl}${config.apiEndpoints.products}`;
    const [products, setProducts] = React.useState([]);
    const [columns, setColumns] = React.useState([
        { label: "Name", key: "name", render: (value) => <b>{value}</b> },
        { label: "Category", key: "category" },
        { label: "Quantity", key: "quantity", render: (value) => <span>{value}</span> },
        { label: "Status", key: "status", render: (value) => <span>{value}</span> },
    ]);

    React.useEffect(() => {
        axios.get(url)
            .then((response) => {
                setProducts(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    return (
        <>
            <div className="flex flex-wrap mt-4 z-10">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Products"
                        route="/admin/products/create"
                        columns={columns}
                        data={products}
                    />
                </div>
            </div>
        </>
    );
}